import { render } from "./PortForwarding.vue?vue&type=template&id=5a76958b&scoped=true"
import script from "./PortForwarding.vue?vue&type=script&lang=js"
export * from "./PortForwarding.vue?vue&type=script&lang=js"

import "./PortForwarding.vue?vue&type=style&index=0&id=5a76958b&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a76958b"]])

export default __exports__